/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserFeedback} from '../models/UserFeedback';

export interface GetAllFeedbacksByChangeRequestId$Request {
    changeRequestId: number;
}

export interface GetAllFeedbacksByChangeRequestId$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAllFeedbacksByChangeRequestIdRequest = createAction<PayloadData<void, GetAllFeedbacksByChangeRequestId$Request>>('USER_FEEDBACK_CONTROLLER__GET_ALL_FEEDBACKS_BY_CHANGE_REQUEST_ID__REQUEST');
export const getAllFeedbacksByChangeRequestIdSuccess = createAction<PayloadData<Array<UserFeedback>, GetAllFeedbacksByChangeRequestId$Request>>('USER_FEEDBACK_CONTROLLER__GET_ALL_FEEDBACKS_BY_CHANGE_REQUEST_ID__SUCCESS');
export const getAllFeedbacksByChangeRequestIdFailure = createAction<PayloadData<Error, GetAllFeedbacksByChangeRequestId$Request, true>>('USER_FEEDBACK_CONTROLLER__GET_ALL_FEEDBACKS_BY_CHANGE_REQUEST_ID__FAILURE');

export const getAllFeedbacksByChangeRequestIdActions = [
    getAllFeedbacksByChangeRequestIdRequest,
    getAllFeedbacksByChangeRequestIdSuccess,
    getAllFeedbacksByChangeRequestIdFailure
] as const;

/**
 * @param {number} meta.changeRequestId Change Request Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAllFeedbacksByChangeRequestId = (meta: GetAllFeedbacksByChangeRequestId$Request, config?: GetAllFeedbacksByChangeRequestId$Config) => {
    return {
        CALL_API: {
            types: getAllFeedbacksByChangeRequestIdActions,
            method: ApiMethods.GET,
            endpoint: `/ai/change-requests/${meta.changeRequestId}/feedbacks`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveFeedback$Request {
    userFeedback: UserFeedback;
}

export interface SaveFeedback$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveFeedbackRequest = createAction<PayloadData<void, SaveFeedback$Request>>('USER_FEEDBACK_CONTROLLER__SAVE_FEEDBACK__REQUEST');
export const saveFeedbackSuccess = createAction<PayloadData<void, SaveFeedback$Request>>('USER_FEEDBACK_CONTROLLER__SAVE_FEEDBACK__SUCCESS');
export const saveFeedbackFailure = createAction<PayloadData<Error, SaveFeedback$Request, true>>('USER_FEEDBACK_CONTROLLER__SAVE_FEEDBACK__FAILURE');

export const saveFeedbackActions = [
    saveFeedbackRequest,
    saveFeedbackSuccess,
    saveFeedbackFailure
] as const;

/**
 * @param {UserFeedback} meta.userFeedback
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveFeedback = (meta: SaveFeedback$Request, config?: SaveFeedback$Config) => {
    return {
        CALL_API: {
            types: saveFeedbackActions,
            method: ApiMethods.POST,
            endpoint: `/ai/change-requests/feedbacks/save`,
            TRANSPORT_REQUEST_BODY: meta.userFeedback,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

